import { Component, OnInit } from '@angular/core';
import { InvoiceHeaderUpsertDto } from 'src/app/invoices/dto/invoice-header-upsert.dto';
import { InvoiceLineItemUpsertDto } from 'src/app/invoices/dto/invoice-line-item-upsert.dto';
import { InvoiceUpsertDto } from 'src/app/invoices/dto/invoice-upsert.dto';
import { FinancialServiceService } from 'src/app/revenue/shared/financial.service';
import { MultiProfileInvoiceDto } from '../../dto/multi-profile-invoice.dto';
import { NotificationService, TranslationService } from 'src/app/shared';
import { RevenueItem } from 'src/app/revenue/shared/revenue-items/revenue-item.model';
import { RevenueItemService } from 'src/app/revenue/shared/revenue-items/revenue-item.service';
import { UserSummaryDto } from 'src/app/users/shared/dto/user-summary.dto';
import { UserService } from 'src/app/users/shared/user.service';
import { UserSearchDto } from 'src/app/users/shared/dto/user-search.dto';
import { BatchService } from 'src/app/revenue/shared/invoice/batch.service';

@Component({
  selector: 'wl-multiple-profile-invoice-modal',
  templateUrl: './multiple-profile-invoice-modal.component.html',
  styleUrls: ['./multiple-profile-invoice-modal.component.less'],
    standalone: false
})
export class MultipleProfileInvoiceModalComponent implements OnInit {
  isVisible: boolean = false;
  isCreating: boolean = false;
  selectedProfiles: number[] = [];
  invoice: InvoiceUpsertDto = {} as InvoiceUpsertDto;
  allRevenueItems: RevenueItem[];
  allUsers: UserSummaryDto[];

  constructor(private _financialService: FinancialServiceService, private _notificationService: NotificationService, private _translationService: TranslationService, private _revenueItemService: RevenueItemService, private _userService: UserService, private _batchService: BatchService) {
    this.invoice = { 
      LineItems: [], 
      InvoiceHeader: {
        InvoiceDate: new Date(),
        DateDue: new Date()
      } as InvoiceHeaderUpsertDto 
    } as InvoiceUpsertDto;
  }

  ngOnInit(): void {
    this._revenueItemService.getAllRevenueItems().then((data) => {
      this.allRevenueItems = data.sort((a, b) => {
        return a.ItemName < b.ItemName ? -1 : a.ItemName > b.ItemName ? 1 : 0;
      });
    });
    this._userService.search({ PageNumber: 0, PageSize: 0, OrderBy: 'UserName:ASC' } as UserSearchDto).then((data) => {
      this.allUsers = data.Result;
    });
  }

  open(selectedProfiles: number[]) {
    this.isVisible = true;
    this.selectedProfiles = selectedProfiles;
    this.invoice.LineItems = [];
  }

  addLineItem() {
    const today = new Date();
    const newInvoiceLineItem = {
      ApplyDate: today,
      ServicePeriod_StartPeriod: today,
      ServicePeriod_EndPeriod: new Date(today.getFullYear() + 1, today.getMonth(), today.getDate() - 1),
      Quantity: 1,
      BasePrice: 0,
      FlatFee: 0,
      AdjustedAmountDue: 0,
      TaxLineItems: [],
      Adjustments: [],
      Payments: [],
      AdjustmentAmountToApply: 0,
    } as InvoiceLineItemUpsertDto;

    this.invoice.LineItems.push(newInvoiceLineItem);
  }

  async createInvoices() {
    this.isCreating = true;
    this.invoice.InvoiceHeader.Batch_Creation = await this._batchService.getNextBatchNumber(new Date().getFullYear());
    this.invoice.LineItems.forEach(item => item.Batch_Creation = this.invoice.InvoiceHeader.Batch_Creation);
    const user = (await this._userService.getCurrentUser());
    this._financialService.multiProfileInvoiceUpsert({ProfileIds: this.selectedProfiles, Invoice: this.invoice, User: user} as MultiProfileInvoiceDto)
    .then(() => {
      this._notificationService.success(
        this._translationService.getInstantTitlecase('common.success')
      );
      this.isVisible = false;
    })
    .catch((err) => {
      this._notificationService.httpError(err);
    })
    .finally(() => {
      this.isCreating = false;
    });
  }

  cancel() {
    this.isVisible = false;
  }
}
